module.exports = __webpack_public_path__ + "static/media/TIME2.3f84f2ac.svg";